import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "produit-area" }
const _hoisted_2 = {
  key: 0,
  class: "page-space-50"
}
const _hoisted_3 = { class: "container-small" }
const _hoisted_4 = {
  class: "s10_mobile position-relative",
  style: {"height":"380px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_5 = {
  key: 0,
  class: "tag-set justify-content-left",
  style: {"top":"0"}
}
const _hoisted_6 = { class: "tag2" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "s9_mobile" }
const _hoisted_9 = { class: "secondary-font mt-5 mb-6" }
const _hoisted_10 = { class: "text-4xl secondary-font mb-5" }
const _hoisted_11 = ["for"]
const _hoisted_12 = { class: "s1 mt-1" }
const _hoisted_13 = ["id", "value"]
const _hoisted_14 = { class: "s14 pl-2 secondary-font" }
const _hoisted_15 = { class: "secondary-font text-grey-600" }
const _hoisted_16 = { class: "s5 text-right secondary-font" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = ["innerHTML"]

import { formatAmount } from '@/utils/formatters';
import { computed, inject, onMounted, reactive, ref, toRaw } from 'vue';
import { useRouter } from 'vue-router';
import { useMarketCartStore } from '@/stores/cart.store';
import { showAlert } from '@/utils/swal';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProduitsDetailsView',
  setup(__props) {

const BACKEND_URL = inject('BACKEND_URL');
const router = useRouter();
const cart = useMarketCartStore();
const layout = ref('none');
const loadingCart = ref(false);
const startupInfos = reactive({
    product: {} as any,
    market_echeances_time: -1,
});
const echeancesPaiement = ref([] as any[]);
const formGroup = reactive({
    mode_paiement: null as string | null,
});

onMounted(() => {
  layout.value = router.currentRoute.value.meta.layout as string || 'none';
  Object.assign(startupInfos, router.currentRoute.value.meta.startup_infos);
  let echeancesOptions: any[] = [];
  if (startupInfos.product.mode_paiement == "echelonne") {
    echeancesOptions = [
        {
            value: "echelonne",
            label: `Payer en ${startupInfos.market_echeances_time} fois`,
            description: `${formatAmount(startupInfos.product.montant_echeance)} F CFA x ${startupInfos.market_echeances_time}`,
            montant: startupInfos.product.montant_apres_remises,
        }
    ];
    formGroup.mode_paiement = "echelonne";
  } else if (startupInfos.product.mode_paiement == "mixed") {
    echeancesOptions = [
        {
            value: "comptant",
            label: 'Payer en une fois',
            description: 'Avec le solde de votre wallet',
            montant: startupInfos.product.montant_apres_remises,
        },
        {
            value: "echelonne",
            label: `Payer en ${startupInfos.market_echeances_time} fois`,
            description: `${formatAmount(startupInfos.product.montant_echeance)} F CFA x ${startupInfos.market_echeances_time}`,
            montant: startupInfos.product.montant_apres_remises,
        }
    ];
    formGroup.mode_paiement = "comptant";
  } else {
    echeancesOptions = [
        {
            value: "comptant",
            label: 'Payer en une fois',
            description: 'Avec le solde de votre wallet',
            montant: startupInfos.product.montant_apres_remises,
        }
    ];
    formGroup.mode_paiement = "comptant";
  }
  echeancesPaiement.value = echeancesOptions;
});

async function addToCart() {
    if (loadingCart.value) { return; }

    loadingCart.value = true;
    try {
        if (formGroup.mode_paiement === 'comptant') {
            await cart.addToCart({
                id: startupInfos.product.id,
                nom: startupInfos.product.nom,
                image: startupInfos.product.image,
                montant: startupInfos.product.montant,
                type_promotion: startupInfos.product.type_promotion,
                taux_promotion: startupInfos.product.taux_promotion,
                valeur_promotion: startupInfos.product.valeur_promotion,
                montant_apres_remises: startupInfos.product.montant_apres_remises,
                mode_paiement: formGroup.mode_paiement,
                montant_echeance: 0,
                nb_echeance: 0,
                total_promotion: 0,
                sous_total: 0,
                total: 0,
                total_echeance: 0,
            });
        } else {
            const echeance = toRaw(echeancesPaiement.value).find(e => e.value === formGroup.mode_paiement);
            if (echeance) {
                await cart.addToCart({
                    id: startupInfos.product.id,
                    nom: startupInfos.product.nom,
                    image: startupInfos.product.image,
                    montant: startupInfos.product.montant,
                    type_promotion: startupInfos.product.type_promotion,
                    taux_promotion: startupInfos.product.taux_promotion,
                    valeur_promotion: startupInfos.product.valeur_promotion,
                    montant_apres_remises: startupInfos.product.montant_apres_remises,
                    mode_paiement: formGroup.mode_paiement!,
                    montant_echeance: startupInfos.product.montant_echeance,
                    nb_echeance: startupInfos.market_echeances_time,
                    total_promotion: 0,
                    sous_total: 0,
                    total: 0,
                    total_echeance: 0,
                });
            }
        }
    } catch(error: any) {
        await showAlert.error(typeof error === 'string' ? error : 'Une erreur est survenue. Veuillez réessayer.');
    } finally {
        loadingCart.value = false;
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      (layout.value == 'none')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (startupInfos.product.type_promotion == 'PERCENTAGE' && startupInfos.product.taux_promotion)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, "-" + _toDisplayString(Math.round(startupInfos.product.taux_promotion)) + "%", 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            src: _unref(BACKEND_URL) + '/assets/market_produits/1000/' + startupInfos.product.image,
            style: {"max-width":"100%","max-height":"350px"}
          }, null, 8, _hoisted_7)
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "s1_mobile" }, " ", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h1", _hoisted_9, _toDisplayString(startupInfos.product.nom), 1),
          _createElementVNode("h1", _hoisted_10, _toDisplayString(_unref(formatAmount)(startupInfos.product.montant_apres_remises)) + " F CFA ", 1),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "h-0" }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(echeancesPaiement.value, (echeance, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["card-check bg-white-50 widget flex my-2 pt-6 pb-5 px-6", {'active': formGroup.mode_paiement === echeance.value}]),
              key: index
            }, [
              _createElementVNode("label", {
                class: "s20",
                for: 'echeance_' + index
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    class: "",
                    type: "radio",
                    name: "echeance",
                    id: 'echeance_' + index,
                    value: echeance.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formGroup.mode_paiement) = $event))
                  }, null, 8, _hoisted_13), [
                    [_vModelRadio, formGroup.mode_paiement]
                  ])
                ]),
                _createElementVNode("h5", _hoisted_14, [
                  _createTextVNode(_toDisplayString(echeance.label) + " ", 1),
                  _cache[1] || (_cache[1] = _createElementVNode("br", { class: "mb-3" }, null, -1)),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(echeance.description), 1)
                ]),
                _createElementVNode("h4", _hoisted_16, _toDisplayString(_unref(formatAmount)(echeance.montant)) + " F", 1)
              ], 8, _hoisted_11)
            ], 2))
          }), 128)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          _createElementVNode("button", {
            class: _normalizeClass(["btn-ultra lg w-100", {'loading': loadingCart.value}]),
            onClick: addToCart,
            disabled: loadingCart.value
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "btn-show" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-panier.svg",
                class: "btn-icon",
                alt: ""
              }),
              _createElementVNode("span", null, " Ajouter au panier")
            ], -1),
            _createElementVNode("div", { class: "btn-loading" }, [
              _createElementVNode("div", { class: "loader-dots" })
            ], -1)
          ]))], 10, _hoisted_17),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "h-30" }, null, -1))
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("p", {
            class: "s10_mobile text-read",
            innerHTML: startupInfos.product.description
          }, null, 8, _hoisted_19),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "s1_mobile" }, " ", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "s9_mobile" }, null, -1))
        ])
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1))
    ])
  ]))
}
}

})